import { render, staticRenderFns } from "./CategoriesListComponent.html?vue&type=template&id=33967f8c&scoped=true&"
import script from "./CategoriesListComponent.js?vue&type=script&lang=js&"
export * from "./CategoriesListComponent.js?vue&type=script&lang=js&"
import style0 from "./CategoriesListComponent.scss?vue&type=style&index=0&id=33967f8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33967f8c",
  null
  
)

export default component.exports